import { useState } from 'react';
import Icon from '@components/common/assets';
import { ProfileInfoType } from '@components/match/profile/types';
import MatchingProfileVO from '@domain/vo/match/MatchingProfileVO';
import Colors from '@domain/constant/colors';
import useIsomorphicLayoutEffect from '@utils/hooks/useIsomorphicLayoutEffect';

import classnames from 'classnames/bind';
import styles from './matchPreparationStatus.module.scss';
const cx = classnames.bind(styles);

interface IMatchPreparationStatusProps {
  profileInfoType: ProfileInfoType;
  matchProfile: MatchingProfileVO;
  matchingConfigYn?: boolean;
}

const MatchPreparationStatus = ({ matchProfile, profileInfoType, matchingConfigYn }: IMatchPreparationStatusProps) => {
  const [count, setCount] = useState(0);
  const isGeneral = profileInfoType === 'GENERAL';
  const isDeveloper = profileInfoType === 'DEVELOPER';
  const isReady = (isGeneral && count === 2) || (isDeveloper && count === 3);
  const isCompleted = isReady && matchingConfigYn;

  useIsomorphicLayoutEffect(() => {
    let count = 0;
    const { applyResults, profile } = matchProfile;
    const { profileRequiredCompleteYn } = profile;

    const accResult = applyResults?.find((result) => result.applyType === 'ACC');
    const paccResult = applyResults?.find((result) => result.applyType === 'PACC');
    const pstResult = applyResults?.find((result) => result.applyType === 'PST');

    if (isGeneral) {
      if (profileRequiredCompleteYn) count++;
      if (accResult) count++;
    } else {
      if (profileRequiredCompleteYn) count++;
      if (paccResult) count++;
      if (pstResult) count++;
    }

    setCount(count);
  }, [profileInfoType, matchProfile]);

  const getStatusText = () => {
    if (isCompleted) {
      return '제안 받는중';
    }
    if (isReady) {
      return '매칭 준비완료';
    }
    return `매칭 준비중 (${count}/${isGeneral ? 2 : 3})`;
  };

  return (
    <div className={cx('container')}>
      <Icon
        name="verifiedLightFilled"
        width={32}
        height={32}
        fill={isCompleted ? Colors.C_BLUE_90 : isReady ? Colors.C_GREEN_150 : Colors.C_COOL_GRAY_50}
      />
      {getStatusText()}
    </div>
  );
};

export default MatchPreparationStatus;
